
import { defineComponent } from "vue";
import PlanPanelPropertyJournal from "@/components/journals/PlanPanelJournal/PlanPanelPropertyJournal.vue";
import PlanPanelLengthJournal from "@/components/journals/PlanPanelJournal/PlanPanelLengthJournal.vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";

export default defineComponent({
  components: {
    PlanPanelPropertyJournal,
    PlanPanelLengthJournal,
  },
  emits: ["updateParent"],
  props: {
    parentModel: { required: true },
    updateParentModelCallback: { required: false },
    parentEditingConfig: { required: false, type: TableEditingConfig },
  },
  methods: {
    updateParent() {
      if (this.updateParentModelCallback) {
        this.updateParentModelCallback();
      }
    },
  },
  data() {
    return {};
  },
});
